import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../service/udnick';

export const PrintSolicitacaoRetornoServices = {
  getImprimeAutorizacaoEntrega: (nuNota: number | undefined): Promise<AxiosResponse> =>
    UDNICK.callService('imprimeAutorizacaoEntrega', { nuNota }),
};
